export default "__VITE_ASSET__CLnID2UP__"